import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter} from 'react-router-dom';
import './index.css';
import './styles/layout.css';
import App from './App.jsx';
import './i18n.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import { measureWebVitals, measureNavigationPerformance } from './utils/performance.js';
import { initializeAsyncErrorHandler } from './utils/asyncErrorHandler.js';

// Initialize global async error handling to catch extension-related errors
initializeAsyncErrorHandler();

// Initialize performance monitoring in development with cleanup
if (import.meta.env.DEV) {
  const cleanupWebVitals = measureWebVitals();
  window.addEventListener('load', measureNavigationPerformance);
  
  // Cleanup on page unload to prevent memory leaks
  window.addEventListener('beforeunload', () => {
    if (cleanupWebVitals) {
      cleanupWebVitals();
    }
  });
}

const root = createRoot(document.getElementById('root'));

root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);